import React from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, width = 560, testid = "modal" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1000] flex items-start justify-center p-4 overflow-y-auto" data-testid={testid} style={{ paddingBottom: "max(1rem, env(safe-area-inset-bottom))" }}>
      <div className="absolute inset-0" style={{ background: "rgba(2,6,12,0.7)", backdropFilter: "blur(2px)" }} onClick={onClose} />
      <div className="relative my-8 w-full" style={{ maxWidth: width, background: "var(--si-surface)", border: "1px solid var(--si-border)", borderRadius: 2 }}>
        <div className="flex items-center justify-between px-5 py-4" style={{ borderBottom: "1px solid var(--si-border)" }}>
          <div className="text-sm font-medium" style={{ color: "var(--si-text)" }}>{title}</div>
          <button data-testid="modal-close" onClick={onClose} style={{ color: "var(--si-text-2)" }}><X size={18} /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
